/* ==========================================================================
   Longevity Pet — Landing "Calendario Longevity Pet 2027"
   Comportamenti: link WhatsApp, polaroid dell'hero, comparsa allo scroll,
   tracking GA4, carosello consigli, FAQ. La barra sticky non ha JS:
   è sempre visibile a raccolta aperta (la nasconde solo .lpcal-if-open).
   Riferimento: _calendario-docs/spec-landing-calendario.md (§ 4.3, § 6, § 8)
   Logica di partenza: _calendario-docs/bozza-filippo-logica.js

   Caricato con defer, una volta sola, dall'hero. Nessuna dipendenza.
   Regola del movimento: lo stato nascosto si applica da qui, mai dal CSS,
   così se il JS non parte la pagina è comunque tutta visibile.
   ========================================================================== */

(function () {
  'use strict';

  var EASE = 'cubic-bezier(.2,.7,.2,1)';

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* ------------------------------------------------------------------
     1. Tracking GA4 (spec § 8)
     gtag diretto, come la landing del quiz. Se gtag non c'è (o i cookie
     analitici sono rifiutati) l'evento non parte e non si rompe niente.
     ------------------------------------------------------------------ */

  function track(name, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params || {});
      }
    } catch (e) { /* il tracking non deve mai bloccare il click */ }
  }

  /* ------------------------------------------------------------------
     2. Link WhatsApp (spec § 6)
     L'hero stampa l'URL completo (numero + testo preimpostato) in
     data-lpcal-wa-url. Ogni .lpcal-wa ha in pagina un href di fallback
     senza testo: qui lo si sostituisce con l'URL dell'hero.
     ------------------------------------------------------------------ */

  function initWhatsApp() {
    var source = document.querySelector('[data-lpcal-wa-url]');
    var url = source ? source.getAttribute('data-lpcal-wa-url') : '';
    var links = document.querySelectorAll('a.lpcal-wa');

    Array.prototype.forEach.call(links, function (link) {
      if (link.hasAttribute('data-lpcal-bound')) return;
      link.setAttribute('data-lpcal-bound', '');

      if (url) link.setAttribute('href', url);

      link.addEventListener('click', function () {
        track('calendario_wa_click', {
          posizione: link.getAttribute('data-posizione') || ''
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     3. Polaroid dell'hero (spec § 4.3)
     Entrano dal basso: translateY(28px) e opacità 0 -> rotazione finale.
     750ms, ritardo 120ms + 130ms x indice. fill: 'backwards' tiene lo
     stato iniziale durante il ritardo, poi l'animazione si toglie da sola
     e resta lo stile del CSS.
     ------------------------------------------------------------------ */

  function initPolaroids() {
    if (prefersReducedMotion()) return;

    var cards = document.querySelectorAll('[data-lpcal-settle]');
    Array.prototype.forEach.call(cards, function (el, i) {
      if (typeof el.animate !== 'function') return;
      var end = 'rotate(' + (parseFloat(el.getAttribute('data-lpcal-settle')) || 0) + 'deg)';
      el.animate(
        [
          { opacity: 0, transform: 'translateY(28px) rotate(0deg)' },
          { opacity: 1, transform: end }
        ],
        { duration: 750, delay: 120 + i * 130, easing: EASE, fill: 'backwards' }
      );
    });
  }

  /* ------------------------------------------------------------------
     4. Comparsa allo scroll (spec § 4.3)
     Figli diretti dei contenitori [data-lpcal-reveal] (sezioni 02-05).
     Si animano solo quelli sotto il 92% dell'altezza della finestra al
     caricamento; gli altri restano come sono. 600ms, translateY(18px).
     ------------------------------------------------------------------ */

  function initReveal() {
    if (prefersReducedMotion()) return;

    var vh = function () {
      return window.innerHeight || document.documentElement.clientHeight;
    };

    var all = [];
    Array.prototype.forEach.call(document.querySelectorAll('[data-lpcal-reveal]'), function (group) {
      Array.prototype.forEach.call(group.children, function (el) { all.push(el); });
    });

    var items = all.filter(function (el) {
      return el.getBoundingClientRect().top > vh() * 0.92;
    });
    if (!items.length) return;

    items.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(18px)';
      el.style.transition = 'opacity 600ms ' + EASE + ', transform 600ms ' + EASE;
    });

    function show(el) {
      el.style.opacity = '';
      el.style.transform = '';
    }

    function check() {
      var lim = vh() * 0.92;
      items = items.filter(function (el) {
        if (!el.isConnected || el.getBoundingClientRect().top < lim) {
          show(el);
          return false;
        }
        return true;
      });
      if (!items.length) stop();
    }

    function stop() {
      window.removeEventListener('scroll', check, true);
      window.removeEventListener('resize', check);
    }

    window.addEventListener('scroll', check, { passive: true, capture: true });
    window.addEventListener('resize', check);
    check();
  }

  /* ------------------------------------------------------------------
     5. Carosello "Quale foto scegliere" (spec § 5.4)
     Indice attivo calcolato dallo scroll con la larghezza reale della
     card + il gap (non il 286 fisso della bozza). A fine corsa è attiva
     l'ultima card. Clic su card o puntino -> scorre a quella card.
     Da 1024px (spec-desktop.md § 6) le card stanno affiancate e il
     carosello non fa niente: niente indice, clic ignorati. Al passaggio
     da desktop a mobile/tablet (ridimensionamento) si riallinea l'indice.
     ------------------------------------------------------------------ */

  var DESKTOP = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : null;

  function isDesktop() {
    return !!(DESKTOP && DESKTOP.matches);
  }

  function initCarousel() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lpcal-carousel]'), function (track) {
      if (track.hasAttribute('data-lpcal-bound')) return;
      track.setAttribute('data-lpcal-bound', '');

      var cards = Array.prototype.slice.call(track.querySelectorAll('[data-lpcal-tip]'));
      if (!cards.length) return;
      var root = track.closest('.lpcal-inner') || track.parentNode;
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-lpcal-dot]'));
      var active = -1;

      // Larghezza card + gap. offsetWidth/offsetLeft ignorano la scala .94
      // delle card non attive, quindi il passo è sempre quello reale.
      function step() {
        if (cards.length > 1) return cards[1].offsetLeft - cards[0].offsetLeft;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return cards[0].offsetWidth + gap;
      }

      function maxScroll() {
        return track.scrollWidth - track.clientWidth;
      }

      function setActive(i) {
        if (i === active) return;
        active = i;
        cards.forEach(function (c, k) { c.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) {
          d.classList.toggle('is-active', k === i);
          if (k === i) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }

      // Da 768px le card si agganciano al centro (CSS): lo dice il valore
      // calcolato di scroll-snap-align della prima card.
      function centered() {
        return getComputedStyle(cards[0]).scrollSnapAlign.indexOf('center') !== -1;
      }

      function centerOf(el) {
        var r = el.getBoundingClientRect();
        return r.left + r.width / 2; // la scala .94 parte dal centro: non lo sposta
      }

      function indexFromScroll() {
        var last = cards.length - 1;
        if (centered()) {
          var mid = centerOf(track), best = 0, dist = Infinity;
          cards.forEach(function (c, k) {
            var d = Math.abs(centerOf(c) - mid);
            if (d < dist) { dist = d; best = k; }
          });
          return best;
        }
        if (track.scrollLeft >= maxScroll() - 2) return last;
        return Math.max(0, Math.min(last, Math.round(track.scrollLeft / step())));
      }

      function targetLeft(i) {
        if (centered()) {
          return Math.max(0, Math.min(maxScroll(), track.scrollLeft + centerOf(cards[i]) - centerOf(track)));
        }
        return Math.min(i * step(), maxScroll());
      }

      function sync() {
        if (isDesktop()) return;
        setActive(indexFromScroll());
      }

      // Il clic dà subito la risposta visiva; a fine movimento si
      // riallinea con la posizione reale (lo scroll animato può essere
      // interrotto da un altro gesto o dal focus, e allora non finisce
      // sulla card cliccata).
      var settle = 0;
      function goTo(i) {
        if (isDesktop()) return;
        track.scrollTo({ left: targetLeft(i), behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
        setActive(i);
        window.clearTimeout(settle);
        settle = window.setTimeout(sync, 700);
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          sync();
        });
      }, { passive: true });
      track.addEventListener('scrollend', sync);

      cards.forEach(function (c, k) {
        c.addEventListener('click', function () { goTo(k); });
      });
      dots.forEach(function (d, k) {
        d.addEventListener('click', function () { goTo(k); });
      });

      // Ritorno sotto i 1024px: lo scroll riparte da dove lo lascia il
      // layout a griglia, quindi si ricalcola la card attiva.
      if (DESKTOP) {
        var onChange = function () {
          window.clearTimeout(settle);
          if (!isDesktop()) sync();
        };
        if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', onChange);
        else if (DESKTOP.addListener) DESKTOP.addListener(onChange);
      }

      sync();
      track.classList.add('is-ready');
    });
  }

  /* ------------------------------------------------------------------
     6. FAQ (spec § 5.5)
     Uno aperto alla volta, tutte chiuse all'avvio. Senza JS le risposte
     restano aperte (le chiude .is-ready). Evento calendario_faq_open con
     il testo della domanda (come la landing del quiz), solo all'apertura.
     ------------------------------------------------------------------ */

  function initFaq() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lpcal-faq]'), function (list) {
      if (list.hasAttribute('data-lpcal-bound')) return;
      list.setAttribute('data-lpcal-bound', '');

      var items = Array.prototype.slice.call(list.querySelectorAll('.lpcal-faq__item'));

      function set(item, open) {
        item.classList.toggle('is-open', open);
        var q = item.querySelector('[data-lpcal-faq-q]');
        if (q) q.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      items.forEach(function (item) {
        set(item, false);
        var q = item.querySelector('[data-lpcal-faq-q]');
        if (!q) return;
        q.addEventListener('click', function () {
          var opening = !item.classList.contains('is-open');
          items.forEach(function (other) { set(other, other === item && opening); });
          if (opening) {
            var testo = q.querySelector('.lpcal-faq__q-text');
            track('calendario_faq_open', { domanda: testo ? testo.textContent.trim() : '' });
          }
        });
      });

      list.classList.add('is-ready');
    });
  }

  /* ------------------------------------------------------------------
     Avvio
     ------------------------------------------------------------------ */

  function init() {
    initWhatsApp();
    initPolaroids();
    initReveal();
    initCarousel();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
